import TreeNode from "./TreeNode";

export default class UserTreeNode extends TreeNode {
    constructor(user, id) {
        super(user, id);
    }

    getIdPrefix() {
        return "u";
    }

    getType() {
        return TreeNode.TYPE_USER
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/UserTreeNode.js